import Nav from './components/nav';
import Posts from './components/posts';

function App() {
  return (
    <div className="container">
      <Nav />
      <Posts />
    </div>
  );
}

export default App;
